<template>
  <div class="confirm_page page">
    <Stage :navNum="5" />
    <div class="confirm_box">
      <span class="title">请确认是否进行账号转移 </span>
      <span class="text">1.本次转移支付费用：<span>¥6.00</span></span>
      <span class="text"
        >2.成功支付费用后将进行转移，届时不可更改转移信息，不可取消转移。</span
      >
      <span class="text"> 3.转移完成后，转移账号在原平台将无法登录游戏。</span>
      <span class="text"
        >4.转移成功后，无法撤销本次转移结果，若您想转回请等<span>12小时后</span>重新付费转移。
      </span>
    </div>
    <div class="btn_box">
      <div class="pre_btn" @click="$parent.currentPage--">上一步</div>
      <div class="next_btn" @click="$parent.currentPage++">下一步</div>
    </div>
  </div>
</template>

<script>
import Stage from './childcomponents/Stage.vue';
export default {
  components: {
    Stage
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {}
};
</script>
<style lang='less' scoped>
.confirm_page {
  .confirm_box {
    width: 100%;
    height: 4.11rem;
    background: #feffff;
    .layout-flex(@col,normal,normal);
    margin-top: 0.36rem;
    padding: 0 0.52rem;
    box-sizing: border-box;
    .title {
      font-weight: 500;
      color: #1b1919;
      font-size: 0.28rem;
      margin-top: 0.6rem;
      margin-bottom: 0.36rem;
    }
    .text {
      font-size: 0.24rem;
      color: #656565;
      line-height: 0.4rem;
      span {
        color: #3e73fe;
      }
    }
  }
  .btn_box {
    margin-top: 3rem;
  }
}
</style>